import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Slider from 'react-compound-slider'
import Handle from './SliderComponents/Handle'
import Track from './SliderComponents/Track'

import tooltips from '../../constants/tooltips.json'

import {
  setZoneSplitPoint
} from '../../actions/'

// move into CSS
const sliderStyle = {
  position: 'relative',
  width: '100%',
  paddingTop: 3
}

class SplitSlider extends Component {
  domain = []

  render() {
    const {
      name,
      label,
      splits,
      selectedSplit,
      onSetSplitPoint,
      autohideSliders,
      disabled,
      showTooltips,
    } = this.props

    this.domain = name === 'zone-a' ? [0,43] : [0,43]

    return (
      <div
        className={
          classnames(
            "split-slider",
            name,
            {"autohide": autohideSliders},
            {"off": name === 'zone-a' && splits[0].bar < 0},
            {"off": name === 'zone-b' && splits[1].bar > 42}
          )
        }
        data-tip={tooltips['editor-splits']}
        data-multiline="true"
        data-place={name === 'zone-a' ? 'top' : 'bottom'}
        data-tip-disable={!showTooltips}
        >
        <div style={{ height: 10, width: '100%' }}>
        <Slider
          mode={(curr, next, step, reversed, getValue) => {
            // console.log('>> slider', curr, next, step, reversed, getValue());
            return next
          }}
          step={1}
          domain={this.domain}
          disabled={disabled}
          rootStyle={sliderStyle}
          onUpdate={(value) => {
              if(splits[1].bar > splits[0].bar){
                if(name === 'zone-b') {
                  onSetSplitPoint(1, 42 - value + 1)
                  onSetSplitPoint(0, splits[1].bar - 1)
                } else{
                  onSetSplitPoint(0, value - 1)
                  onSetSplitPoint(1, splits[0].bar + 1)
                }
              } else {
                onSetSplitPoint(selectedSplit, name === 'zone-a' ? value - 1 : 42 - value + 1)
              }
            }
          }
          values={name === 'zone-a' ? [splits[0].bar + 1] : [(42 - splits[1].bar) + 1]}
          reversed={name === 'zone-a' ? false : true}
        >
          <Slider.Rail>
            {({ getRailProps }) => (
              <div className='slider-rail' {...getRailProps()} />
            )}
          </Slider.Rail>
          <Slider.Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map(handle => (
                  <Handle
                    key={handle.id}
                    handle={handle}
                    domain={this.domain}
                    label={label}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Slider.Handles>
          <Slider.Tracks left={(name === 'zone-a') ? true : false} right={(name === 'zone-a') ? false : true}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <Track
                    key={id}
                    source={source}
                    target={target}
                    label={label}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Slider.Tracks>
        </Slider>
      </div>
    </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    selectedSplit: state.editor.selectedSplit,
    splits: state.currentPreset.splits,
    autohideSliders: state.editorPreferences.autohideSliders,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSplitPoint: (zone, bar) => {
      dispatch(setZoneSplitPoint(zone, ~~bar))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SplitSlider)
